module.exports = __webpack_public_path__ + "img/icon_jobs.7468fe50.svg";